<template>
  <section id="home-page-hot-offers">
    <div class="container">
      <div class="row">

        <clearfix :biggest="true"></clearfix>

        <div class="col-sm-12 content og-bg-dark">
          <h3>{{ $t('message.title.site.hot_offers') }}</h3>
        </div>
      </div>

      <div class="row" v-show="hotCars.length === 0">
        <clearfix :wide="true"></clearfix>

        <div class="col-sm-12 content og-bg-light">
          {{ $t('message.text.cars.no_cars') }}
        </div>
      </div>

      <div class="row" v-show="hotCars.length > 0" v-for="car in hotCars">

        <clearfix :wide="true"></clearfix>

        <div class="col-sm-12 content og-bg-light">
          <h4>
            <router-link :to="{name: 'Car', params: {id: car.id}}">{{ car.brand }} {{ car.model }} ({{ car.year }})</router-link>
          </h4>

          <div class="car-photo" v-show="car.photos.length > 0"
               :style="{ backgroundImage: 'url(\'' + $t(imageBase, {car_id: car.id, file_name: getPhotoFileName(car.photos)}) + '\')', width: '300px', height: '200px' }">
          </div>

          <div class="car-description" v-html="car.description"></div>
        </div>
      </div>

      <clearfix :biggest="true"></clearfix>
    </div>
  </section>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Clearfix from '@/components/utils/Clearfix'
  import config from './Config'

  Vue.use(VueAxios, axios)

  export default {
    data () {
      return {
        hotCars: [],
        imageBase: config.urls.image_url
      }
    },
    methods: {
      getPhotoFileName(photos) {
        if (photos.length > 0) {
          return photos[0].fileName
        }
        return ''
      }
    },
    components: {
      Clearfix
    },
    created() {
      Vue.axios.get(config.urls.hot_cars)
        .then((response) => {
          this.hotCars = response.data
        })
    }
  }
</script>

<style>
  #home-page-hot-offers {
    background: url('../../assets/img/bg/bg_renault_engine.jpg') center fixed no-repeat;
    background-size: cover;
    height: auto;
    margin: 0 auto;
    width: 100%;
    position: relative;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// HotOffers.vue?b5dd760e